import React from 'react';
import HeroSection from '../../components/HeroSection';
import StrategySection from '../../components/StrategySection';
import MissionSection from '../../components/MissionSection';
import EntryPointSection from '../../components/EntryPointSection';
import SEO from '../components/SEO';
import ErrorBoundary from '../components/ErrorBoundary';
const HomePage = () => {
  // Structured data for organization
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Legacy Lab Financial',
    description: 'Access the private wealth lab built for entrepreneurs, investors, and empire-builders ready to multiply their income, influence, and legacy.',
    url: 'https://legacylabfinancial.com',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6enBba7nGTipGJpvGovp6X/IMG_1828.jpg',
    sameAs: ['https://expert.minnect.com/@CurtisAndSpringEatmon'],
    founder: {
      '@type': 'Person',
      name: 'Curtis & Spring Eatmon'
    }
  };
  return <>
      <SEO title="Home" description="Access the private wealth lab built for entrepreneurs, investors, and empire-builders ready to multiply their income, influence, and legacy." structuredData={structuredData} data-id="element-466" />
      <ErrorBoundary data-id="element-467">
        <HeroSection data-id="element-468" />
      </ErrorBoundary>
      <ErrorBoundary data-id="element-469">
        <StrategySection data-id="element-470" />
      </ErrorBoundary>
      <ErrorBoundary data-id="element-471">
        <MissionSection data-id="element-472" />
      </ErrorBoundary>
      <ErrorBoundary data-id="element-473">
        <EntryPointSection data-id="element-474" />
      </ErrorBoundary>
    </>;
};
export default HomePage;